import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OwnershipTypeDto, LessorsDto, TerrainDto, BankDto, LessorRepTypeDto, IndividualAcreagesDto, LessorRepresentativeDto, LessorInfoDto, LessorStakeholderDto, DamageListDto, AddressBookDto, UomDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { Guid } from 'guid-typescript';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LessorModalComponent } from '../bulkandsurfaceright/lessor-modal/lessor-modal.component';
import { SearchDamageListComponent } from './search-damage-list/search-damage-list.component';

@Component({
  selector: 'cradua-enumeratedandagreage',
  templateUrl: './enumeratedandagreage.component.html',
  styleUrls: ['./enumeratedandagreage.component.css']
})
export class EnumeratedandagreageComponent implements OnInit {
  paymentForm: FormGroup;
  @Output() submitevent = new EventEmitter();
  @Output() searchEvent = new EventEmitter();
  @Output() deleteEvent = new EventEmitter();
  @Input() LandTitleSerialNo: string;
  @Input() ownershiptypes: OwnershipTypeDto[];
  @Input() quantums: any[];
  @Input() lessors: LessorsDto[];
  @Input() terrains: TerrainDto[];
  @Input() itemList: DamageListDto[];
  @Input() measures: UomDto[];
  @Input() addressbooks: AddressBookDto[];
  @Input() lessorInfos: LessorInfoDto[];
  @Input() lessorRepresentatives: LessorRepresentativeDto[];
  @Input() lessorStakeholders: LessorStakeholderDto[];
  @Input() banks: BankDto[];
  @Input() lessorRepTypes: LessorRepTypeDto[];
  @Input()  individualAcreages: IndividualAcreagesDto[];
  @Input() PaymentType: any;
  @Output() addressssearchevent = new EventEmitter();
  filteredPayment = [];
  filteredDelete = [];
  OwnershipTypeId: string;
  TerrianName: string;
  ownerName: string;
  Ownerners: string;
  LandType: string;
  lessorType: string;
  listView = true;
  gridView = false;

    constructor(
      private fb: FormBuilder,
      private matSnackBar: MatSnackBar,
      public dialog: MatDialog,
      ) { }

    ngOnInit(): void {
      this.addPayment();
    }

      ngOnChanges(): void {
        setTimeout(() => {
          this.filteredData()
        }, 100);
      }

    selectPayment(payment) {
      if(!payment.isNew) {
        this.paymentForm.patchValue({isNew: false});
      }
      this.paymentForm.patchValue(payment);
    }

    onList() {
      this.listView = true;
      this.gridView = false;
    }

    onGrid() {
      this.gridView = true;
      this.listView = false;
    }

    onLessorDialog(type: string) {

      const dialogConfig = new MatDialogConfig();

      // dialogConfig.disableClose = false;
      dialogConfig.id = "lessor-modal-component";
      dialogConfig.height = "90%";
      dialogConfig.width = "100%";


      dialogConfig.data = {
        lessorInfos: this.lessorInfos,
        lessorRepresentatives: this.lessorRepresentatives,
        lessorRepTypes: this.lessorRepTypes,
        lessorStakeholders: this.lessorStakeholders,
        addressBooks: this.addressbooks,
        individualAcreages: this.individualAcreages,
        banks: this.banks,
        terrains: this.terrains,
        measures: this.measures,
        type,
      }
      const dialogRef = this.dialog.open(
        LessorModalComponent,
        dialogConfig,
      );

      dialogRef.afterClosed().subscribe((result: any) => {
        if(result != null && type === 'lessorInfo') {
          this.lessorType = result?.type;
          this.OwnershipTypeId = result?.lessorInfo?.OwnershipTypeId;
          this.Ownerners = result?.lessorInfo?.AddressBookId;
          this.LandType = result?.acreage?.TerrainId;
          this.paymentForm.patchValue({
          OwnershipTypeId: result?.lessorInfo?.OwnershipTypeId,
          Owners: result?.lessorInfo?.AddressBookId,
          ownerName: result?.lessorInfo?.AccountName,
          OwnershipTypeName: result?.lessorInfo?.OwnershipTypeName,
          TerrianName: this.getTerrain(result?.acreage?.TerrainId),
            LandType: result?.acreage?.TerrainId,
            Terrain_TerrainId: result?.acreage?.TerrainId,
          });
          this.setLessorPaymentForm();
        } else if(result != null && type === 'representative') {
          this.lessorType = result?.type;
          const lessorInfo = this.getLessorInfo(result?.representative?.LessorsId);
          this.OwnershipTypeId = lessorInfo?.OwnershipTypeId;
          this.Ownerners = result?.representative?.AddressBookId;
          this.paymentForm.patchValue({
          OwnershipTypeId: lessorInfo?.OwnershipTypeId,
          Owners: result?.representative?.AddressBookId,
          LandType: lessorInfo?.TerrainId,
          ownerName: result?.representative?.addressBook?.Name,
          OwnershipTypeName: lessorInfo?.OwnershipTypeName,
          });
          this.setLessorPaymentForm();
        } else if(result != null && type === 'stakeholder') {
          this.lessorType = result?.type;
          const lessorInfo = this.getLessorInfo(result?.representative?.LessorsId);
          this.OwnershipTypeId = lessorInfo?.OwnershipTypeId;
          this.Ownerners = result?.representative?.AddressBookId;
          this.paymentForm.patchValue({
          OwnershipTypeId: lessorInfo?.OwnershipTypeId,
          Owners: result?.representative?.AddressBookId,
          LandType: lessorInfo?.TerrainId,
          ownerName: result?.representative?.addressBook?.Name,
          OwnershipTypeName: lessorInfo?.OwnershipTypeName,
          });
          this.setLessorPaymentForm();
        }
      });

    }

    getTerrain(id: string) {
      return this.terrains.find(terrain => terrain.id === id)?.TerrainName || null;
    }

    getLessorInfo(id: string): LessorInfoDto {
      return this.lessorInfos.find(lessor => lessor.id === id) || null;
    }

    onSearchDamageList() {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = "damage-list-modal-component";
      dialogConfig.height = "90%";
      dialogConfig.width = "100%";

      dialogConfig.data = {
        measures: this.measures
      }
      const dialogRef = this.dialog.open(
        SearchDamageListComponent,
        dialogConfig,
      );

      dialogRef.afterClosed().subscribe((result: any) => {
       if(result != null) {
        this.paymentForm.patchValue({
          CompanyApprovedRate: result.CompanyApprovedRate,
          Rate: result.OptApprovedRate,
          ItemName: result.ItemName,
          MeasureName: result.MeasureName
        });
          this.calcAmount();
       }
      });
    }


    addPayment() {
      this.paymentForm = this.fb.group({
        id: Guid.create().toString(),
        PaymentType: [this.PaymentType],

        isNew: true,
        PaymentStatus: ['PENDING'],
        Amount: [0.0,  Validators.required],
        NegotiatedAmount: [0.0,  Validators.required],
        CompanyApprovedRate: [0.0],
        OwnershipTypeId: [this.OwnershipTypeId],
        LandType: [this.LandType,  Validators.required],
        TerrianName: [this.TerrianName,  Validators.required],
        ownerName: [this.ownerName,  Validators.required],
        Owners: [this.Ownerners,  Validators.required],
        ItemName: ['', Validators.required],
        LandTitleSerialNo: [this.LandTitleSerialNo],
        Payment: 'Surface',
        Area: [0.0],
        Rate: [0.0],
        Qty: [0.0],
        MeasureName: ['',  Validators.required],
        Remarks: [''],
      });
      }


      setLessorPaymentForm() {
        this.filteredPayment =  this.lessors.filter(a =>
        (a.Owners === this.Ownerners &&
        a.OwnershipTypeId === this.OwnershipTypeId) &&
        (a.LandType === this.LandType && this.LandTitleSerialNo === a.LandTitleSerialNo)
        && (a.Payment ==='Surface')
        ).map(e => {
          return{
            id: e.id,
            PaymentType: e.PaymentType,
            isNew: false,
            PaymentStatus: e.PaymentStatus,
            Amount: e.Amount,
            NegotiatedAmount: e.NegotiatedAmount,
            CompanyApprovedRate: e.CompanyApprovedRate,
            OwnershipTypeId: e.OwnershipTypeId,
            LandType: e.LandType,
            TerrianName: e.TerrianName,
            ownerName: e.ownerName,
            Owners: e.Owners,
            ItemName: e.ItemName,
            Payment: e.Payment,
            Area: e.Area,
            Rate: e.Rate,
            Qty: e.Qty,
            MeasureName: e.MeasureName,
            Remarks: e.Remarks,
            ApprovalRemarks: e.ApprovalRemarks,
          }
        });
      }

      setPaymentForm() {
        this.filteredPayment =  this.lessors.filter(a =>
        (a.Owners === this.Ownerners &&
        a.OwnershipTypeId === this.OwnershipTypeId) &&
        (a.LandType === this.LandType && this.LandTitleSerialNo === a.LandTitleSerialNo)
        && (a.Payment ==='Surface')
        ).map(e => {
          return{
            id: e.id,
            PaymentType: e.PaymentType,
            isNew: false,
            PaymentStatus: e.PaymentStatus,
            Amount: e.Amount,
            NegotiatedAmount: e.NegotiatedAmount,
            CompanyApprovedRate: e.CompanyApprovedRate,
            OwnershipTypeId: e.OwnershipTypeId,
            LandType: e.LandType,
            TerrianName: e.TerrianName,
            ownerName: e.ownerName,
            Owners: e.Owners,
            ItemName: e.ItemName,
            Payment: e.Payment,
            Area: e.Area,
            Rate: e.Rate,
            Qty: e.Qty,
            MeasureName: e.MeasureName,
            Remarks: e.Remarks,
            ApprovalRemarks: e.ApprovalRemarks,
          }
        })
       this.patchData();
      }

      filteredData() {
      this.filteredPayment =  this.lessors.filter(payment => payment.Payment ==='Surface' && this.LandTitleSerialNo === payment.LandTitleSerialNo).map(e => {
          return{
            id: e.id,
            PaymentType: e.PaymentType,
            isNew: false,
            PaymentStatus: e.PaymentStatus,
            Amount: e.Amount,
            NegotiatedAmount: e.NegotiatedAmount,
            CompanyApprovedRate: e.CompanyApprovedRate,
            OwnershipTypeId: e.OwnershipTypeId,
            LandType: e.LandType,
            TerrianName: e.TerrianName,
            ownerName: e.ownerName,
            Owners: e.Owners,
            ItemName: e.ItemName,
            Payment: e.Payment,
            Area: e.Area,
            Rate: e.Rate,
            Qty: e.Qty,
            MeasureName: e.MeasureName,
            Remarks: e.Remarks,
            ApprovalRemarks: e.ApprovalRemarks,
          }
        })
      }
      patchData() {
        this.paymentForm.patchValue({
          Owners: this.Ownerners,
          OwnershipTypeId: this.OwnershipTypeId,
          LandType: this.LandType,
          TerrianName: this.TerrianName,
          PaymentType: this.PaymentType
        })
      }
      selectaddressbook(book: AddressBookDto) {
        this.ownerName = book.Name;
        this.Ownerners = book.id;
        this.setPaymentForm();
      }

       selectItem(item: DamageListDto) {
         this.paymentForm.patchValue({
          CompanyApprovedRate: item.CompanyApprovedRate,
          Rate: item.OptApprovedRate,
          ItemName: item.ItemName,
          MeasureName: item.MeasureName
        });

          this.calcAmount();
       }

       calcAmount() {
        const amount = this.paymentForm.value.Rate * this.paymentForm.value.Qty;
        this.paymentForm.patchValue({
          NegotiatedAmount: amount,
          Amount: amount
        });
       }

       calcTotal() {
        const amount = {
          totalAmount: 0,
          totalNegotiated: 0
         }

       this.filteredPayment.map((a) => {
          amount.totalAmount += a.Amount;
          amount.totalNegotiated += a.NegotiatedAmount;
        });

        return amount;
       }

       searchAddressBook(name: string) {
       this.addressssearchevent.emit(name);
      }

      searchItem(value) {
        this.searchEvent.emit(value);
      }

        selectTerrain(terrain: TerrainDto, i: number) {
          this.LandType = terrain.id;
          this.TerrianName = terrain.TerrainName;
          this.setPaymentForm();
        }

        selectOwnershipType(ownertype: OwnershipTypeDto) {
          this.OwnershipTypeId = ownertype.id
          this.setPaymentForm();
        }

      deleteLessor(data) {
        Swal.fire({
          title: 'Are you sure?',
          text: 'You will not be able to recover this imaginary file!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it'
        }).then((result) => {
          if (result.value) {

      this.filteredPayment =     this.filteredPayment= this.lessors.filter(lessor => lessor.id !== data.id);

      if(data.id && !data.isNew) {
        this.deleteEvent.emit(data.id);
      }

      Swal.fire(
              'Deleted!',
              'Your imaginary file has been deleted.',
              'success'
            );
          } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.fire(
                'Cancelled',
                'Your imaginary file is safe :)',
                'error'
              );
            }
          });
      }


      savePayment(lessor) {
        if(this.paymentForm.valid) {
          this.addPayment();
            this.patchData();
            this.filteredPayment = this.filteredPayment.filter(les => les.id !== lessor.id);
            this.filteredPayment.unshift(lessor);
        } else {
          this.matSnackBar.open('please fill all required fields!', 'Exit', {duration: 3000});
        }
      }

      onSubmit(data) {

      data =   data.map(e => {
          if(e.isNew) {delete e.id}
         return e;
        });

        if(data.length > 0) {
          const newdata = {Lessors: data};
          this.submitevent.emit(newdata)
        } else {
          this.matSnackBar.open('You dont have any item in the list to submit!', 'Exit', {duration: 3000});
        }
      }
}
